var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.75h-4.25v-.5a5.75 5.75 0 0 0-11.5 0v.5H6c-.553 0-1 .447-1 1V27.5c0 .553.447 1 1 1h20c.553 0 1-.447 1-1V10.75c0-.553-.447-1-1-1zm-6.5 0h-7v-.5c0-1.934 1.566-3.5 3.5-3.5s3.5 1.566 3.5 3.5v.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.514745342f697e0f8d2a1878d3eb3b37.svg";
export { ForwardRef as ReactComponent };